(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('ajax', ['$rootScope', '$http', '$timeout', 'csrfToken', '$q', '$window', function ajaxFactory($rootScope, $http, $timeout, csrfToken, $q, $window) {
            var defaultParams = {};

            var postSuccess = function (response, deferred) {
                if (response.data.success) {
                    deferred.resolve(response.data.data);
                } else {
                    // If the response includes an error message, display it
                    // Otherwise it will be up to the code which created this promise to handle displaying the error
                    if (response.data.message) {
                        var header = response.data.header || 'Hmm... something went wrong';
                        var message = 'Try it again but if you have further issue, shoot us an email.';
                        var params = {};

                        if (response.data.message !== 'Unknown Error') {
                            message = response.data.message;
                            params.buttons = [];

                            params.buttons.push({ name: 'Close', colorClass: 'btn--primary-alt' });

                            if (response.showEditThemeButton) {
                                params.buttons.push({ name: 'Edit Intro', href: 'videos/intro', colorClass: 'btn--primary' });
                            }

                            if (response.showContact) {
                                params.showContact = true;
                            }
                        } else { params.showContact = true; }

                        params.header = header;
                        $rootScope.$broadcast('open-message', message, params);
                    }

                    deferred.reject(response ? response.data.data : undefined);
                }
            };

            var postFailure = function (status, deferred, url, silent, xhrStatus) {
                deferred.reject();

                var header = 'Hmm... something went wrong';
                var message = 'Try it again but if you have further issue, shoot us an email.';
                var params = {};

                if (status === 401) { message = 'You do not have the correct permissions to perform this action.'; }

                if (!silent) {
                    params.header = header;
                    params.showContact = true;
                    $rootScope.$broadcast('open-message', message, params);
                }

                // Deliberately aborted requests (e.g. a cancelor resolved when filters change) are not
                // errors — don't report them to Bugsnag. Genuine failures (server errors, network,
                // timeouts) still report.
                if ($window.Bugsnag && xhrStatus !== 'abort') {
                    Bugsnag.notify(new Error('Ajax Post Error'), function (event) {
                        event.addMetadata('status', {
                            _url: url,
                            _status: status,
                        });
                    });
                }
            };

            this.setDefaultParams = function (params) {
                defaultParams = params;
            };

            this.get = function (url, data, params, tries, deferred) {
                var contextThis = this;

                if (!data) {
                    data = {};
                }

                // data should come in with an existing project_id if the
                // request is coming from the contact profile where
                // data is accessible across projects
                // example: user is logged in to project 7 but wants to
                // preview a contact's video from project 11
                if (!data.project_id && $rootScope.currentProject) {
                    data.project_id = $rootScope.currentProject.id;
                }

                angular.forEach(defaultParams, function (defaultParam, key) {
                    data[key] = defaultParam;
                });

                var d = {
                    params: data,
                };

                if (params && params.cancelor) {
                    d.timeout = params.cancelor.promise;
                }

                if (!deferred) {
                    deferred = $q.defer();
                }

                $http.get(url, d)
                    .then(function (response) { // params (response, status, headers, config)
                        if (response.data.success) {
                            deferred.resolve(response.data.data);
                        } else {
                            deferred.reject();
                        }
                    })
                    .catch(function () { // params (response, status, headers, config)
                        if ((!params || (!params.cancelor && !params.dontRetry)) && !tries) {
                            $timeout(function () {
                                contextThis.get(url, data, params, tries ? tries + 1 : 1, deferred);
                            }, 150);
                        } else {
                            deferred.reject();
                        }
                    });

                return deferred.promise;
            };

            this.post = function (url, data, params) {
                if (!data) { data = {}; }

                data._token = csrfToken; // eslint-disable-line no-underscore-dangle

                if ($rootScope.currentProject) { data.project_id = $rootScope.currentProject.id; }

                angular.forEach(defaultParams, function (defaultParam, key) {
                    data[key] = defaultParam;
                });

                var deferred = $q.defer();
                var httpParams = {
                    method: 'POST',
                    url: url,
                    data: data,
                };

                if (params && params.cancelor) { httpParams.timeout = params.cancelor.promise; }

                $http(httpParams).then(function (response) { // params (response, status, headers, config)
                    postSuccess(response, deferred);
                }).catch(function (response) { // params (response, status, headers, config)
                    postFailure(response.status, deferred, url, params ? params.silent : false, response.xhrStatus);
                });

                return deferred.promise;
            };

            this.download = function (url, data, fileName) {
                if (!data) { data = {}; }

                data._token = csrfToken; // eslint-disable-line no-underscore-dangle

                if ($rootScope.currentProject) { data.project_id = $rootScope.currentProject.id; }

                angular.forEach(defaultParams, function (defaultParam, key) {
                    data[key] = defaultParam;
                });

                var deferred = $q.defer();
                var httpParams = {
                    method: 'POST',
                    url: url,
                    data: data,
                };

                $http(httpParams).then(function (response) { // params (response, status, headers, config)
                    var anchor = angular.element('<a/>');

                    anchor.attr({
                        href: 'data:attachment/csv;charset=utf-8,' + encodeURI(response.data.content),
                        target: '_blank',
                        download: fileName,
                    })[0].click();

                    deferred.resolve();
                }).catch(function () { // params (response, status, headers, config)
                    deferred.reject();
                });

                return deferred.promise;
            };

            this.put = function (url, data, params) {
                if (!data) { data = {}; }

                data._token = csrfToken; // eslint-disable-line no-underscore-dangle

                if ($rootScope.currentProject) { data.project_id = $rootScope.currentProject.id; }

                angular.forEach(defaultParams, function (defaultParam, key) {
                    data[key] = defaultParam;
                });

                var deferred = $q.defer();

                $http({
                    method: 'PUT',
                    url: url,
                    data: data,
                }).then(function (response) { // params (response, status, headers, config)
                    postSuccess(response, deferred);
                }).catch(function (response) { // params (response, status, headers, config)
                    postFailure(response.status, deferred, url, params ? params.silent : false, response.xhrStatus);
                });

                return deferred.promise;
            };

            this.delete = function (url, data, params) {
                if (!data) { data = {}; }

                data._token = csrfToken; // eslint-disable-line no-underscore-dangle

                if ($rootScope.currentProject) { url += '?project_id=' + $rootScope.currentProject.id; }

                angular.forEach(defaultParams, function (defaultParam, key) {
                    data[key] = defaultParam;
                });

                var deferred = $q.defer();

                $http({
                    method: 'DELETE',
                    url: url,
                    data: data,
                }).then(function (response) { // params (response, status, headers, config)
                    postSuccess(response, deferred);
                }).catch(function (response) { // params (response, status, headers, config)
                    postFailure(response.status, deferred, url, params ? params.silent : false, response.xhrStatus);
                });

                return deferred.promise;
            };

            return this;
        }]);
}());
